import React from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import { getTrainerNutritionPlans } from '../ducks/nutritionActions';
import NutritionList from './NutritionList';
import './nutrition.scss';

class Nutrition extends React.Component {
  componentDidMount() {
    this.props.getNutritionPlans();
  }

  render() {
    if (this.props.nutrationLoadingState) {
      return(<Loader />);
    }
    return (
      <div className="nutrition main-wrapper">
        <div className="container">
          <div className="page-title">
            <h4>Nutrition</h4>
            <div className="title-action">
              <a href="/nutrition/new" className="btn btn-primary">
                Create Plan
              </a>
            </div>
          </div>
          {this.props.plans && <NutritionList plans={this.props.plans} />}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    plans: state.nutritionReducer.trainerNutrition.plans,
    nutrationLoadingState: state.nutritionReducer.trainerNutrition.nutrationLoadingState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNutritionPlans: () => dispatch(getTrainerNutritionPlans())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nutrition);
